import {
    VERTICAL_DATA_ATTRIBUTE,
    VERTICAL_VALUES,
    HORIZONTAL_DATA_ATTRIBUTE,
    HORIZONTAL_VALUES
} from '../constants';
import { LocationsType } from '../types';
import {
    TOP_LOCATIONS,
    CENTER_LOCATIONS,
    BASE_STYLE
} from './constants';

/**
 * A toaster tray element.
 */
export default class Tray {
    private readonly location: LocationsType;
    element: HTMLUListElement;

    constructor(location: LocationsType) {
        this.location = location;
        this.element = this.create();
    }

    get verticalDataValue() {
        return TOP_LOCATIONS.includes(this.location)
            ? VERTICAL_VALUES.TOP
            : VERTICAL_VALUES.BOTTOM;
    }

    get horizontalDataValue() {
        return CENTER_LOCATIONS.includes(this.location)
            ? HORIZONTAL_VALUES.CENTER
            : HORIZONTAL_VALUES.EDGE;
    }

    /**
     * Generates a tray element.
     */
    create() {
        const tray = document.createElement('ul');

        tray.setAttribute(VERTICAL_DATA_ATTRIBUTE, this.verticalDataValue);
        tray.setAttribute(HORIZONTAL_DATA_ATTRIBUTE, this.horizontalDataValue);
        Object.assign(tray.style, BASE_STYLE);

        return tray;
    }
}
